export { default } from  './src/index.js';



//////////////////
// WEBPACK FOOTER
// ./node_modules/crossfilter2/main.js
// module id = Kt3Z
// module chunks = 0